import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Linkedin, ArrowRight } from 'lucide-react';
import { aboutData } from '../data/mock';

export const About = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 sm:py-24 lg:py-32 bg-slate-950 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-1/3 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 sm:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-white to-slate-400 bg-clip-text text-transparent">
              {aboutData.title}
            </span>
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto space-y-8 mb-16">
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed text-center">
            {aboutData.description}
          </p>
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed text-center">
            {aboutData.mission}
          </p>
        </div>

        {/* Founder Card */}
        <Card className="max-w-4xl mx-auto bg-slate-900/50 border-slate-800/50 backdrop-blur-sm overflow-hidden hover:border-blue-500/50 transition-all duration-300">
          <div className="grid md:grid-cols-3 gap-0">
            {/* Image Section */}
            <div className="relative h-80 md:h-auto overflow-hidden">
              <img
                src={aboutData.founder.image}
                alt={aboutData.founder.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent md:bg-gradient-to-r"></div>
            </div>

            {/* Content Section */}
            <CardContent className="md:col-span-2 p-6 sm:p-8 lg:p-10 flex flex-col justify-center">
              <div className="mb-6">
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                  {aboutData.founder.name}
                </h3>
                <p className="text-lg text-blue-400 font-medium mb-4">
                  {aboutData.founder.title}
                </p>
                <p className="text-slate-300 leading-relaxed">
                  {aboutData.founder.bio}
                </p>
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  onClick={() => window.open(aboutData.founder.linkedin, '_blank')}
                  variant="outline"
                  className="border-slate-700 hover:border-blue-500 text-white hover:bg-slate-800/50 transition-all duration-300 group"
                >
                  <Linkedin className="w-4 h-4 mr-2" />
                  Connect on LinkedIn
                </Button>
                <Button
                  onClick={() => scrollToSection('contact')}
                  className="bg-blue-500 hover:bg-blue-600 text-white transition-all duration-300 group"
                >
                  Work With Us
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </CardContent>
          </div>
        </Card>
      </div>
    </section>
  );
};
